import {
    createContext,
    ReactNode,
    useContext,
    useEffect,
    useState,
} from 'react';
import { supabase } from '../../configs/supabase';
import type { User } from '@supabase/supabase-js';
  
export type GlobalAuthState = {
    user: User | null | undefined;
    loading: boolean;
};
  
const initialState: GlobalAuthState = {
    user: undefined,
    loading: true,
};

const AuthContext = createContext<GlobalAuthState>(initialState);

type Props = { children: ReactNode };
  
export const AuthProvider = ({ children }: Props) => {
    const [state, setState] = useState<GlobalAuthState>(initialState);

    useEffect(() => {
        const fetchSession = async () => {
            const { data: { session } } = await supabase.auth.getSession();
            setState({ user: session?.user ?? null, loading: false });
        };
        fetchSession();

        const { data: authListener } = supabase.auth.onAuthStateChange(
            (_event, session) => {
                setState({ user: session?.user ?? null, loading: false });
            }
        );

        return () => {
            authListener.subscription?.unsubscribe();
        };
        
    }, []);

    return <AuthContext.Provider value={state}>{children}</AuthContext.Provider>;
};

export const useAuthContext = () => useContext(AuthContext);
